import React from "react";

export type SegmentedTab<T extends string> = {
  id: T;
  label: React.ReactNode;
};

type SegmentedTabsProps<T extends string> = {
  activeTab: T;
  tabs: SegmentedTab<T>[];
  onChange: (tab: T) => void;
  className?: string;
};

export function SegmentedTabs<T extends string>({
  activeTab,
  tabs,
  onChange,
  className = "",
}: SegmentedTabsProps<T>) {
  return (
    <div
      className={`inline-flex w-fit rounded-lg border border-gray-200 bg-gray-50 p-1 ${className}`}
      role="tablist"
    >
      {tabs.map((tab) => {
        const isActive = activeTab === tab.id;
        return (
          <button
            key={tab.id}
            type="button"
            role="tab"
            aria-selected={isActive}
            onClick={() => onChange(tab.id)}
            style={{ backgroundColor: isActive ? "#ffffff" : "#f1f5f9" }}
            className={`rounded-md px-4 py-2 text-sm font-medium transition-colors ${
              isActive
                ? "text-gray-900 shadow-sm"
                : "text-gray-500 hover:text-gray-700"
            }`}
          >
            {tab.label}
          </button>
        );
      })}
    </div>
  );
}
